import { type ReactNode } from "react";

import { Stack, Typography } from "@mui/material";

export default function MessageStack({
  icon,
  color = "primary",
  message,
  description,
}: {
  icon: ReactNode;
  color: "primary" | "error";
  message: string;
  description?: string;
}) {
  return (
    <Stack
      sx={{
        gridColumn: "1 / -1",
        justifyContent: "center",
        alignItems: "center",
        p: 8,
        textAlign: "center",
      }}
    >
      <Typography variant="h1" color={color} sx={{ display: "flex", mb: 2 }}>
        {icon}
      </Typography>
      <Typography variant="h5">{message}</Typography>
      {description && <Typography>{description}</Typography>}
    </Stack>
  );
}
